export default {
  allBanks: [],
}
